// Presentation-only store-button ordering by device OS (not browser brand).
// iPhone/iPad/iPod (including touch-capable iPadOS reporting as Macintosh)
// see the App Store button first; Android and unknown desktops keep the
// Google Play button first. Both links always render, enabled, identical
// styling — this never redirects, blocks, or claims device compatibility.
function userAgent(): string {
  return typeof navigator === "undefined" ? "" : navigator.userAgent || "";
}

function touchPoints(): number {
  if (typeof navigator === "undefined") return 0;
  return typeof navigator.maxTouchPoints === "number" ? navigator.maxTouchPoints : 0;
}

export function isIOSDevice(): boolean {
  const ua = userAgent();
  if (/iPhone|iPad|iPod/i.test(ua)) return true;
  // Modern iPadOS reports a desktop Macintosh UA with touch support.
  // A real Mac desktop has no touch points, so it never matches here.
  if (/Macintosh|MacIntel/i.test(ua) && touchPoints() > 1) return true;
  return false;
}

export function isAndroidDevice(): boolean {
  return /Android/i.test(userAgent());
}

export function storeOrder(): "ios-first" | "android-first" {
  return isIOSDevice() ? "ios-first" : "android-first";
}
